import { lazy } from "react"; //insures components are loaded correctly as actual React components rather than Promises.

const routes =[
    {
        path: "/",
        name: "Asset Manager",
        component: lazy(() => import("./assetManager/AssetManager"))
      },
      {
        path: "/login",
        name: "Login",
        component: lazy(() => import("./LoginComponent"))
      },
      {
        path: '/manageData',
        name: "Manage Data",
        component: lazy(() => import("./manageData/ManageData"))
      }
];

export default routes;
